import { create } from "zustand";

/* Store Types */
interface AppUpdateState {
  availableBuildId: string | null;
  setAvailableBuildId: (buildId: string | null) => void;
}

/*
 * App Update Store
 *
 * Tracks the build id of a newer published build (null while this tab is
 * current), so the app can transparently reload at the next safe moment.
 */
export const useAppUpdateStore = create<AppUpdateState>((set) => ({
  availableBuildId: null,

  /* Actions */
  setAvailableBuildId: (buildId) => set({ availableBuildId: buildId }),
}));
